import { axiosApi } from "../../../../../api/dbAxios";

export const generateField = async (
  fieldName: string,
  summary: string,
  id: string,
  code: string,
  regulator: string,
) => {
  const test_email = "rborodinov@deloittece.com";
  const isLocalhost =
    typeof window !== "undefined" && window.location.hostname === "localhost";

  const params = new URLSearchParams();
  params.append("field", fieldName);
  params.append("code", code);
  params.append("id", id);
  params.append("regulator", regulator);
  if (isLocalhost) params.append("test_email", test_email);

  if (fieldName === "short_summary" && summary) {
    params.append("summary", summary);
  }

  try {
    const { data } = await axiosApi.post(
      `/add_record/${code}/${id}/ai_generate_field/`,
      params,
    );
    return data;
  } catch (error: any) {
    const resp = error?.response;
    const raw = resp?.data;
    let msg = error?.message ?? resp?.statusText ?? "Error";
    try {
      if (raw) {
        let s = typeof raw === "string" ? raw : JSON.stringify(raw);
        if (s.startsWith(")]}',")) {
          const idx = s.indexOf("{");
          if (idx >= 0) s = s.slice(idx);
        }
        try {
          const p = JSON.parse(s);
          msg = p?.error ?? p?.message ?? msg;
        } catch {
          const m = s.match(/"error"\s*:\s*"([^"]+)"/);
          if (m) msg = m[1];
        }
      }
    } catch {}
    throw new Error(String(msg));
  }
};
